<template>
  <div class="wrap">
    <div class="leftBox">
      <img-box
        class="insert"
        :imgSrc="dynamicImg.invoiceInsert"
        :activeImg="dynamicImg.invoiceInsertAct"
        title="发票读入"
        @click.native="fpdr()"
      ></img-box>
      <div class="toTopRight">
        <img :src="dynamicImg.toUpRight" alt="" />
      </div>
      <img-box
        class="distribution"
        :imgSrc="dynamicImg.invoiceDis"
        :activeImg="dynamicImg.invoiceDisAct"
        title="发票分配"
      ></img-box>
      <div class="toBtmRight">
        <img :src="dynamicImg.toDownRight" alt="" />
      </div>
      <img-box
        class="back"
        :imgSrc="dynamicImg.invoiceBack"
        :activeImg="dynamicImg.invoiceBackAct"
        title="发票退回"
        @click.native="fpth()"
      ></img-box>
    </div>
    <div class="midBox">
      <div class="toRightImg">
        <img :src="dynamicImg.toRight" alt="" />
      </div>
      <img-box
        class="box"
        :imgSrc="dynamicImg.stockQuery"
        :activeImg="dynamicImg.stockQueryAct"
        title="库存查询"
        @click.native="fpcx()"
      ></img-box>
      <div class="toLeftImg">
        <img :src="dynamicImg.toLeft" alt="" />
      </div>
    </div>
    <div class="rightBox">
      <img-box
        class="box"
        :imgSrc="dynamicImg.onlineApply"
        :activeImg="dynamicImg.onlineApplyAct"
        title="网上申领"
        @click.native="wssl()"
      ></img-box>
      <div class="toDownImg">
        <img :src="dynamicImg.toDown" alt="" />
      </div>
      <img-box
        class="box"
        :imgSrc="dynamicImg.onlineBuy"
        :activeImg="dynamicImg.onlineBuyAct"
        title="网上领票"
        @click.native="wslp()"
      ></img-box>
      <div class="toDownImg">
        <img :src="dynamicImg.toDown" alt="" />
      </div>
      <img-box
        class="box"
        :imgSrc="dynamicImg.onlineTicketing"
        :activeImg="dynamicImg.onlineTicketingAct"
        title="网上分票"
      ></img-box>
    </div>
    <invoice-insert ref="InvoiceInsertForm"></invoice-insert>
    <stock-query ref="StockQueryForm"></stock-query>
    <invoice-back ref="InvoiceBackForm"></invoice-back>
    <online-apply-status ref="OnlineApplyStatusForm"></online-apply-status>
    <online-draw ref="OnlineDrawForm"></online-draw>
  </div>
</template>

<script>
import ImgBox from '@/components/ImgBox/Index'
import InvoiceInsert from './InvoiceInsert.vue'
import InvoiceBack from './InvoiceBack.vue'
import StockQuery from './StockQuery.vue'
import OnlineApplyStatus from './OnlineApplyStatus.vue'
import OnlineDraw from './OnlineDraw.vue'
import { dynamicImg } from '@/utils/dynamicImg'
import { mapGetters } from 'vuex'

export default {
  components: {
    ImgBox,
    InvoiceInsert,
    StockQuery,
    InvoiceBack,
    OnlineApplyStatus,
    OnlineDraw,
  },
  data() {
    return {
      dynamicImg,
    }
  },
  computed: {
    ...mapGetters('practice', ['TASK_DATA']),
  },
  methods: {
    showChild(type) {
      switch (type) {
        case 'fpdr':
          this.fpdr()
          break
        case 'fpcx':
          this.fpcx()
          break
        case 'fpth':
          this.fpth()
          break
        case 'wssl':
          this.wssl()
          break
        case 'wslp':
          this.wslp()
          break
      }
    },
    // 发票读入
    fpdr() {
      const task = this.TASK_DATA[4]
      if (task == null) {
        this.$notification['success']({
          message: '开票业务已完成',
        })
        return
      }
      this.$refs.InvoiceInsertForm.show(0)
    },
    // 发票查询
    fpcx() {
      this.$refs.StockQueryForm.show()
    },
    // 发票退回
    fpth() {
      this.$refs.InvoiceBackForm.show()
    },
    // 网上申领
    wssl() {
      this.$refs.OnlineApplyStatusForm.show()
    },
    // 网上领票
    wslp() {
      this.$refs.OnlineDrawForm.show()
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 900px;
  height: 600px;
  display: block;
  position: relative;
  // border: 1px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leftBox {
  flex-basis: 45%;
  background-color: #fff;
  border-radius: 20px;
  position: relative;
  height: 70%;
  .insert {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 49%;
    left: 18%;
  }
  .distribution {
    position: absolute;
    top: 3%;
    right: 30px;
  }
  .back {
    position: absolute;
    right: 30px;
    bottom: 2%;
  }
  .toTopRight {
    position: absolute;
    top: 37%;
    left: 39%;
  }
  .toBtmRight {
    position: absolute;
    bottom: 37%;
    left: 39%;
  }
}
.midBox {
  flex-basis: 30%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rightBox {
  // height: 100%;
  flex-basis: 20%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  padding: 1%;
}
</style>
